import { AppData } from "../../types/app";

const app: AppData = {
  slug: "dokbox",
  name: "독박스",
  summary: "모임에서 누가 쏠지 미니게임 한 판으로 정하는 파티 게임 앱",
  category: "게임",
  platforms: ["ios", "android"],
  status: "review",
  released_at: "2026-10-21",
  pinned: false,
  icon: "/apps/dokbox/icon.png",
  has_account: false,
  operator: { name: "벨롭스엑스", email: "admin@kwangbok.me" },
  role: "1인 개발, 기획부터 스토어 배포 준비까지",
  why:
    "커피값이나 뒷정리를 정할 때 쓰는 사다리, 손가락 뽑기 앱은 결과가 밋밋하게 끝나고, 10명이 넘으면 한 명씩 조작하느라 늘어진다. 걸린 순간을 다 같이 구경하는 장면으로 만들고 싶어서, 폰 한 대를 가운데 두고 2~20명이 가입 없이 바로 하는 게임 모음을 만들었다. 결과는 매판 새로 뽑는 난수와 물리 시뮬레이션이 정하고, 연출은 결과를 바꾸지 않는다.",
  features: [
    { title: "미니게임 13종", body: "폰을 돌려 가며 하는 차례형 8종(카드 뒤집기, 업다운 폭탄, 반응속도 등)과 다 같이 지켜보는 관전형 5종(마블 레이스, 스모 링, 하수구 회오리 등)이 있다." },
    { title: "공정한 결과", body: "판마다 새 난수로 물리 시뮬레이션을 돌려 결과를 낸다. 마블 레이스는 매번 코스를 새로 섞는 랜덤 코스와 고정 코스 5개가 있다." },
    { title: "판 설정", body: "2~20명, 이번 판만 넣는 손님, 커피 N잔이나 야식 같은 벌칙, 당첨자 수를 고른다." },
    { title: "결과 연출과 패배 인증서", body: "당첨 장면과 놀림 문구, 다시 뽑기 투표가 있다. 번호가 붙은 패배 인증서를 사진으로 저장하거나 공유한다." },
    { title: "그룹과 기록", body: "그룹별로 이번 주, 이번 달, 전체 순위와 독박왕을 본다. 기록은 기기 안에만 저장한다." },
  ],
  screenshots: [
    { src: "/apps/dokbox/01-home.png", alt: "홈 화면. 그룹 선택, 바로 시작 버튼, 게임 13종 목록" },
    { src: "/apps/dokbox/02-marble-race.png", alt: "마블 레이스 진행 화면. 구슬이 핀과 막대 사이로 떨어진다" },
    { src: "/apps/dokbox/03-loser.png", alt: "당첨 결과 화면. 오늘의 독박 민수, 커피 6잔" },
  ],
  policy: {
    privacy: {
      effective_at: "2026-11-01",
      previous: [
        {
          effective_at: "2026-10-29",
          note: "GitHub Pages와 앱 안에 게시한 방침",
          href: "/apps/dokbox/archive/2026-10-29/privacy.html",
        },
      ],
      sections: [
        {
          id: "purpose",
          title: "처리 목적",
          body: [
            "독박스(이하 \"앱\")는 회원가입이 없고, 이름이나 연락처처럼 이용자를 직접 알아볼 수 있는 정보를 운영자가 수집하지 않습니다. 앱이 운영자에게 보내는 정보도 없습니다.",
            "다만 앱에 들어 있는 Google AdMob이 광고 제공, 광고 성과 측정, 부정 클릭 같은 광고 사기 방지, 광고 동의 확인을 위해 2항의 정보를 처리합니다.",
            "광고 제거 구독의 결제는 Apple(App Store)과 Google(Google Play)이 이용자의 스토어 계정에서 처리합니다. 운영자는 결제 정보를 받지 않으며, 앱은 구독 중인지만 기기에서 확인합니다.",
          ],
        },
        {
          id: "items",
          title: "처리하는 개인정보 항목",
          body: [
            "광고 제거 구독 중에는 광고 SDK를 시작하지 않아 아래 광고 항목을 수집하지 않습니다.",
            "기기에만 저장하는 항목은 운영자에게 보내지 않으며 운영자도 볼 수 없습니다. 기기 백업(iCloud, Google 계정 백업)을 켜 두면 백업에 함께 들어갈 수 있습니다.",
            "앱은 카메라, 마이크, 위치, 연락처 권한을 쓰지 않습니다. 패배 인증서를 사진 앱에 저장할 때만 iOS는 사진 추가 권한을, Android는 9 이하에서만 저장공간 권한을 묻고, 저장된 사진을 읽지 않습니다.",
          ],
          table: {
            head: ["구분", "항목", "수집 시점"],
            rows: [
              [
                "Google AdMob 자동 수집",
                "광고 식별자(Android 광고 ID, iOS는 추적을 허용한 경우에만 IDFA)",
                "광고 SDK 시작, 광고 동의 확인, 광고 요청 때",
              ],
              ["Google AdMob 자동 수집", "기기 모델, 운영체제 버전, IP 주소", "광고 SDK 시작, 광고 동의 확인, 광고 요청 때"],
              ["Google AdMob 자동 수집", "광고를 본 기록과 누른 기록", "광고를 보거나 누를 때"],
              ["기기에만 저장", "그룹 이름, 멤버 이름, 판 기록, 인증서 번호", "이용자가 입력하거나 판을 마칠 때"],
              ["기기에만 저장", "앱 설정, 앱 언어, 광고 빈도 기록, 구독 상태", "설정을 바꾸거나 광고, 구독을 확인할 때"],
            ],
          },
        },
        {
          id: "retention",
          title: "보유와 이용 기간",
          body: [
            "운영자가 보관하는 개인정보는 없습니다.",
            "기기에 저장한 정보는 이용자가 앱에서 지우거나 앱을 삭제할 때까지 기기에 남습니다.",
            "Google AdMob이 수집한 정보는 Google 개인정보처리방침(policies.google.com/privacy)에서 정한 기간 동안 보관됩니다.",
          ],
        },
        {
          id: "third-party",
          title: "제3자 제공",
          body: [
            "2항의 Google AdMob 수집 항목은 광고 제공, 광고 성과 측정, 광고 사기 방지를 위해 Google LLC로 보내지며, Google 개인정보처리방침에 따라 처리됩니다. Google은 이 방침과 같은 수준 이상으로 정보를 보호합니다.",
            "이용자가 패배 인증서를 공유하면 이용자가 고른 앱으로 이미지가 전달되며, 그 뒤의 처리는 그 앱의 방침을 따릅니다.",
            "이 밖에는 이용자의 정보를 제3자에게 제공하지 않습니다.",
          ],
        },
        {
          id: "outsourcing-transfer",
          title: "처리 위탁과 국외 이전",
          body: [
            "4항의 Google 제공은 국외 이전에 해당해 아래에 적습니다.",
            "운영자가 개인정보 처리를 맡긴 업체는 없습니다. 이용 분석 도구와 크래시 리포팅 도구도 쓰지 않습니다.",
            "Google AdMob 수집 항목은 아래와 같이 국외로 이전됩니다. 앱이 광고 SDK를 시작하고 광고를 요청할 때 네트워크로 전송됩니다.",
            "국외 이전을 원하지 않으면 광고 제거 구독을 이용할 수 있습니다. 구독 중에는 광고 SDK를 시작하지 않습니다.",
          ],
          table: {
            head: ["업체", "이전 목적", "이전 국가", "이전 항목", "보유 기간", "연락처"],
            rows: [
              [
                "Google LLC (Google AdMob, User Messaging Platform)",
                "광고 제공, 광고 성과 측정, 광고 사기 방지, 광고 동의 확인",
                "미국 등 Google 서버 소재 국가",
                "광고 식별자, 기기 모델, 운영체제 버전, IP 주소, 광고를 본 기록과 누른 기록",
                "Google 개인정보처리방침에서 정한 기간",
                "policies.google.com/privacy",
              ],
            ],
          },
        },
        {
          id: "destruction",
          title: "파기 절차와 방법",
          body: [
            "운영자가 보관하는 개인정보가 없어 운영자가 파기할 정보는 없습니다.",
            "기기 데이터는 이용자가 직접 지우며, 지운 정보는 기기에서 바로 삭제되어 되살릴 수 없습니다. 설정의 기록 관리에서 판 기록을 하나씩 지우거나, 그룹별 기록을 초기화하거나, 전체 데이터 초기화로 그룹, 멤버, 판 기록, 순위, 인증서 번호를 한 번에 지울 수 있습니다.",
            "공유를 위해 만든 인증서 이미지 임시 파일은 다음 공유 때 덮어쓰며, 전체 데이터 초기화 때 함께 지웁니다.",
            "앱을 삭제하면 기기에 저장된 정보도 모두 지워지며, 운영자는 이를 복구할 수 없습니다.",
          ],
        },
        {
          id: "rights",
          title: "정보주체의 권리와 행사 방법",
          body: [
            "기기에 저장된 그룹, 멤버, 판 기록은 이용자가 앱에서 직접 보고, 고치고, 지울 수 있습니다.",
            "iOS에서는 기기 설정의 개인정보 보호 및 보안, 추적에서 추적 허용을 끌 수 있고, 허용하지 않아도 앱의 모든 기능을 쓸 수 있습니다. Android에서는 기기 설정에서 광고 ID를 지우거나 재설정할 수 있습니다.",
            "유럽 등 동의가 필요한 지역에서는 앱 설정의 \"개인정보 선택\"에서 광고 동의를 바꿀 수 있습니다.",
            "그 밖의 열람, 정정, 삭제, 처리 정지 요청은 9항의 메일로 보내 주시면 영업일 기준 3일 안에 답변합니다. 법정대리인이나 위임받은 사람도 대신 요청할 수 있습니다. Google AdMob이 수집한 정보는 Google의 절차로 요청할 수 있습니다.",
            "개인정보 침해에 대한 상담이나 피해 구제는 개인정보침해신고센터(118, privacy.kisa.or.kr), 개인정보분쟁조정위원회(1833-6972, www.kopico.go.kr), 대검찰청(1301, www.spo.go.kr), 경찰청(182, ecrm.police.go.kr)에 문의할 수 있습니다.",
          ],
        },
        {
          id: "security",
          title: "안전성 확보 조치",
          body: [
            "운영자 서버와 계정이 없어 이용자 정보가 운영자 쪽에 쌓이지 않습니다.",
            "기기 데이터는 운영체제가 앱마다 나눈 저장 공간에 두며, 다른 앱은 읽을 수 없습니다.",
            "필요한 권한만 요청합니다. 사진은 추가만 하고 읽지 않으며, 광고 동의와 추적 허용을 거부해도 앱의 모든 기능을 쓸 수 있습니다.",
          ],
        },
        {
          id: "privacy-officer",
          title: "개인정보 보호책임자",
          body: ["운영자: 벨롭스엑스(대표 이광복, 사업자등록번호 881-04-03888)", "개인정보 보호책임자: 이광복, admin@kwangbok.me", "개인정보와 관련한 문의, 불만, 피해 구제 요청은 위 메일로 보내 주세요."],
        },
        {
          id: "changes",
          title: "방침의 변경",
          body: [
            "이 방침은 2026년 11월 1일부터 시행합니다.",
            "내용이 바뀌면 시행 7일 전까지 앱 업데이트 안내와 이 페이지로 알립니다. 이용자에게 불리하거나 중요한 변경은 30일 전까지 알립니다.",
          ],
        },
      ],
    },
    terms: {
      effective_at: "2026-11-01",
      previous: [
        {
          effective_at: "2026-10-29",
          note: "GitHub Pages에 게시한 약관",
          href: "/apps/dokbox/archive/2026-10-29/terms.html",
        },
      ],
      sections: [
        {
          id: "purpose",
          title: "목적",
          body: [
            "이 약관은 벨롭스엑스(이하 \"운영자\")가 제공하는 독박스 앱(이하 \"앱\")을 이용하는 데 필요한 조건과 절차, 운영자와 이용자의 권리와 의무를 정하는 것을 목적으로 합니다.",
          ],
        },
        {
          id: "definitions",
          title: "정의",
          body: [
            "\"앱\"은 운영자가 iOS와 Android로 배포하는 독박스 앱을 말합니다.",
            "\"이용자\"는 앱을 설치해 이 약관에 따라 이용하는 사람을 말합니다.",
            "\"판\"은 벌칙을 맡을 사람을 정하는 게임 한 번을 말합니다.",
            "\"광고 제거 구독\"은 앱의 전면 광고를 없애는 한 달 단위 자동 갱신 유료 구독을 말합니다.",
          ],
        },
        {
          id: "effect-and-changes",
          title: "약관의 효력과 변경",
          body: [
            "이 약관은 앱 안과 이 페이지에 게시해 효력이 생깁니다.",
            "운영자는 관련 법령을 어기지 않는 범위에서 약관을 바꿀 수 있으며, 바꾸는 경우 시행 7일 전까지 앱 업데이트 안내와 이 페이지로 알립니다. 이용자에게 불리하거나 중요한 변경은 30일 전까지 알립니다.",
          ],
        },
        {
          id: "service",
          title: "서비스의 제공과 변경",
          body: [
            "앱은 여러 사람 가운데 벌칙을 맡을 한 사람을 게임으로 정하는 기능을 제공합니다.",
            "앱은 회원가입 없이 이용할 수 있으며, 그룹, 멤버, 판 기록은 이용자의 기기 안에만 저장됩니다. 앱을 지우면 기기에 저장된 데이터도 함께 지워지며, 운영자는 이를 복구할 수 없습니다.",
            "게임 결과는 판마다 기기 안의 물리 계산과 난수, 참가자의 플레이로 정해지며, 운영자는 결과를 미리 정하거나 바꾸지 않습니다.",
            "앱은 무료로 제공되며, 광고가 나올 수 있습니다. 광고를 없애는 유료 구독은 5항을 따릅니다.",
            "운영자는 서비스 내용을 바꿀 수 있으며, 바꾸는 경우 시행 7일 전까지 앱 업데이트 안내로 알립니다. 이용자에게 불리하거나 중요한 변경은 30일 전까지 알립니다.",
          ],
        },
        {
          id: "paid-service",
          title: "유료 서비스와 환불",
          body: [
            "광고 제거 구독은 한 달 단위로 판매하며, 가격은 구매 화면에 표시된 금액입니다.",
            "구독은 해지하지 않으면 매달 자동으로 갱신되고, 요금은 App Store 또는 Google Play 계정으로 청구됩니다. 결제는 Apple과 Google이 처리하며, 운영자는 결제 정보를 받지 않습니다.",
            "해지는 각 스토어의 구독 관리에서 언제든 할 수 있으며, 해지해도 이미 결제한 기간이 끝날 때까지 광고 없이 이용할 수 있습니다.",
            "환불은 Apple과 Google의 환불 정책을 따릅니다. App Store 구매는 Apple의 문제 신고 페이지(reportaproblem.apple.com)에서, Google Play 구매는 Google Play의 주문 내역에서 환불을 요청합니다.",
            "기기를 바꾸거나 앱을 다시 설치한 경우 설정의 \"구매 복원\"으로 구독을 다시 적용할 수 있습니다.",
            "가격을 올리는 경우 각 스토어의 절차에 따라 미리 알립니다.",
          ],
        },
        {
          id: "user-obligations",
          title: "이용자의 의무와 금지 행위",
          body: [
            "놀림 문구는 함께 웃자는 뜻으로 만든 것이며, 특정인을 깎아내리거나 괴롭히는 데 쓰지 않아야 합니다.",
            "이용자가 직접 넣은 그룹 이름, 멤버 이름, 벌칙 내용과 이를 공유한 결과에 대한 책임은 이용자에게 있습니다.",
            "이용자는 앱을 변조해 배포하거나 광고를 부정하게 누르는 행위를 해서는 안 됩니다.",
          ],
        },
        {
          id: "content-rights",
          title: "콘텐츠의 권리",
          body: [
            "앱의 게임, 놀림 문구, 해설 자막, 디자인에 대한 권리는 운영자에게 있습니다.",
            "이용자가 넣은 이름과 벌칙 내용은 이용자의 기기에만 저장되며, 운영자는 이를 받거나 쓰지 않습니다.",
            "앱은 게임 결과에 맞춰 장난스러운 놀림 문구와 해설 자막을 보여 주며, 놀림 문구는 언제나 가장 센 단계로 나옵니다. 불쾌한 놀림 문구나 부적절한 광고는 admin@kwangbok.me로 알려 주시면 다음 업데이트에서 고칩니다.",
          ],
        },
        {
          id: "suspension",
          title: "서비스 중단과 이용 제한",
          body: [
            "운영자는 천재지변 등 어쩔 수 없는 사유가 있으면 서비스 제공을 멈출 수 있습니다.",
            "앱은 계정이 없어 운영자가 개별 이용자의 이용을 제한하는 절차는 없습니다.",
          ],
        },
        {
          id: "liability",
          title: "책임의 제한",
          body: [
            "게임 결과와 그에 따른 벌칙은 참가자끼리 정한 놀이이며, 운영자는 고의 또는 중대한 과실이 없는 한 그로 인해 생긴 일에 대해 책임을 지지 않습니다.",
            "운영자는 기기 고장, 앱 삭제, 운영체제 문제로 기기에 저장된 데이터가 사라진 경우 이를 복구할 의무가 없습니다.",
            "운영자는 천재지변 등 어쩔 수 없는 사유로 서비스를 제공하지 못한 경우 책임을 지지 않습니다.",
          ],
        },
        {
          id: "dispute",
          title: "분쟁 해결과 준거법",
          body: [
            "운영자와 이용자 사이의 분쟁은 먼저 문의 메일(admin@kwangbok.me)로 협의해 해결합니다.",
            "이 약관은 대한민국 법에 따라 해석하며, 소송이 필요한 경우 관할 법원은 민사소송법에 따른 법원으로 합니다.",
          ],
        },
        {
          id: "addendum",
          title: "부칙",
          body: ["이 약관은 2026년 11월 1일부터 시행합니다."],
        },
      ],
    },
  },
  faq: [
    {
      q: "가입해야 쓰나요?",
      a: "아니요. 회원가입과 로그인이 없고, 이름만 넣으면 바로 한 판을 시작합니다.",
    },
    {
      q: "기록은 어디에 저장되나요?",
      a: "그룹, 멤버, 판 기록은 이 기기에만 저장되고 운영자에게 보내지 않습니다. 앱을 지우면 함께 지워지고 복구할 수 없습니다.",
    },
    {
      q: "결과를 운영자가 조작하나요?",
      a: "아니요. 판마다 기기 안의 물리 계산과 난수, 참가자의 플레이로 정해지고, 운영자는 결과를 미리 정하거나 바꾸지 않습니다. 결과 직전에 잠깐 멈추는 장면은 연출이며 결과를 바꾸지 않습니다.",
    },
    {
      q: "광고를 없앨 수 있나요?",
      a: "설정의 \"광고 제거\" 월 구독(대한민국 기준 1,100원)을 하면 전면 광고가 나오지 않고, 광고 동의 폼과 추적 허용 질문도 나오지 않습니다. 기기를 바꾸면 설정의 \"구매 복원\"을 누릅니다.",
    },
    {
      q: "구독은 어떻게 해지하나요?",
      a: "App Store 또는 Google Play의 구독 관리에서 언제든 해지할 수 있고, 이미 결제한 기간이 끝날 때까지 광고 없이 씁니다. 환불은 Apple과 Google의 정책을 따릅니다.",
    },
    {
      q: "내 데이터를 지우려면 어떻게 하나요?",
      a: "설정의 기록 관리에서 판 기록 삭제, 그룹별 기록 초기화, 전체 데이터 초기화를 할 수 있습니다. 계정이 없어 별도의 계정 삭제 절차는 없습니다.",
    },
  ],
};

export default app;
